import { render, staticRenderFns } from "./ChangeHistoryIndex.vue?vue&type=template&id=08ab6a24&scoped=true&"
import script from "./ChangeHistoryIndex.vue?vue&type=script&lang=js&"
export * from "./ChangeHistoryIndex.vue?vue&type=script&lang=js&"
import style0 from "./ChangeHistoryIndex.vue?vue&type=style&index=0&id=08ab6a24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ab6a24",
  null
  
)

export default component.exports